import { useEffect, useState } from "react";
import { CalendarDays, Loader2, Phone } from "lucide-react";

const fmtDay = (iso) =>
  new Date(iso + "T00:00:00").toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

export function CalendarView({ api, onOpenLead }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/appointments").then((r) => setItems(r.data.appointments)).catch(() => setItems([]));
  }, [api]);

  if (items === null)
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="h-6 w-6 animate-spin text-navy-900" />
      </div>
    );

  const groups = items.reduce((acc, l) => {
    const d = l.appointment?.date || "Unscheduled";
    (acc[d] = acc[d] || []).push(l);
    return acc;
  }, {});
  const dates = Object.keys(groups).sort();
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div data-testid="calendar-view">
      {dates.length === 0 ? (
        <div className="rounded-2xl border border-warm-200 bg-white p-12 text-center">
          <CalendarDays className="h-8 w-8 text-warm-300 mx-auto mb-3" />
          <p className="text-sm text-slate-500">
            No visits scheduled yet. Open a lead and add a visit date to see it here.
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {dates.map((d) => (
            <section key={d}>
              <h2 className={`font-serif text-xl mb-3 ${d < today ? "text-slate-400" : "text-slate-900"}`}>
                {fmtDay(d)}
                {d === today && <span className="ml-2 rounded-full bg-navy-900 text-white px-2.5 py-0.5 text-[10px] font-sans font-bold uppercase tracking-wide">Today</span>}
              </h2>
              <ul className="space-y-2.5">
                {groups[d].map((l) => (
                  <li key={l.id}>
                    <button
                      type="button"
                      data-testid={`calendar-visit-${l.id}`}
                      onClick={() => onOpenLead(l)}
                      className="w-full text-left rounded-2xl border border-warm-200 bg-white p-4 shadow-sm hover:shadow-md hover:border-navy-800/30 transition-all flex flex-wrap items-center gap-x-5 gap-y-1"
                    >
                      <span className="rounded-xl bg-navy-900 text-white px-3 py-2 text-sm font-semibold min-w-16 text-center">
                        {l.appointment?.time || "—"}
                      </span>
                      <span className="min-w-36">
                        <span className="block text-sm font-semibold text-slate-900">{l.firstName} {l.lastName}</span>
                        <span className="block text-xs text-slate-500">{l.interest || "General enquiry"}</span>
                      </span>
                      <span className="text-xs text-slate-600">{l.postcode || "—"}</span>
                      {l.phone && (
                        <span className="inline-flex items-center gap-1.5 text-xs text-navy-900 font-medium">
                          <Phone className="h-3.5 w-3.5" /> {l.phone}
                        </span>
                      )}
                      {l.appointment?.note && <span className="text-xs text-slate-400 w-full">{l.appointment.note}</span>}
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
